module.exports = __webpack_public_path__ + "img/hjk2.b1117243.jpg";